<div *ngIf="formState$ | async as formState">
  <form [ngrxFormState]="formState">
    <div class="sideBtnPanel">
      <button class="btn btn-primary"
              name="save-btn"
              [ngClass]="{'btn-right-open': formState.isDirty && formState.isUnsubmitted}"
              [disabled]="formState.isPristine || formState.isSubmitted || formState.isInvalid"
              (click)="saveDevices()"><i class="glyphicon glyphicon-ok"></i> &nbsp;Save Changes
      </button>

    </div>

    <div>
      <strong>User:</strong>&nbsp;
      <span *ngIf="selectedUser$ | async as selectedUser">{{ selectedUser.userName}}
        ({{selectedUser.userId}})</span>
      <img [hidden]="!(loadIndicator$ | async)" src="img/loading.gif" class="spinner" style=" width: 16px"/>
    </div>

    <!-- TODO: Hide form fields and text below while initially loading user devices and available devices and keep hidden if loading fails and retry cancelled -->

    <div>
      Select devices to use for the selected user (check a checkbox to select a device).
      This is only necessary when system defaults are not suitable (e.g. for Two Way Texting to work).
    </div>

    <div *ngIf="formState.controls.smsDevice as smsDevice">
      <div class="device-item">
        <label class="col-md-2">
          <input type="checkbox" [ngrxFormControlState]="smsDevice.controls.isChecked"
                 [disabled]="formState.isSubmitted"/>
          <span style="margin-left:10px;text-transform: capitalize; ">SMS</span>
        </label>

        <div>
          <select class="col-md-2 form-control device-list new-device"
                  [disabled]="formState.isSubmitted || !smsDevice.controls.isChecked.value"
                  [ngrxFormControlState]="smsDevice.controls.deviceId">
            <option *ngFor="let device of devicesSms$ | async" [value]="device.deviceId">{{ device.deviceId }}</option>
          </select>
        </div>

        <input class="form-control device new-device"
               [class.error]="smsDevice.controls.userSenderAddress.isInvalid === true"
               [disabled]="formState.isSubmitted  || !smsDevice.controls.isChecked.value"
               [ngrxFormControlState]="smsDevice.controls.userSenderAddress"
               (change)="unMarkAsShared(smsDevice);"
               (keypress)="unMarkAsShared(smsDevice);"
               name="sms-device-address"
               placeholder="phone number"/>

        <button class="btn btn-primary" type="button"
                [disabled]="formState.isSubmitted || !smsDevice.controls.isChecked.value"
                style="width: 180px; margin-left: 40px;"
                tooltip="Open list of phone numbers shared by multiple users (not useful for Two Way Texting)"
                (click)="showSharedNumbersDialog()">
          Select Shared Numbers
        </button>
      </div>

      <div *ngIf="formState.controls.emailDevice as emailDevice">
        <div class="device-item">
          <label class="col-md-2">
            <input type="checkbox" [ngrxFormControlState]="emailDevice.controls.isChecked"
                   [disabled]="formState.isSubmitted"/>
            <span style="margin-left:10px;text-transform: capitalize; ">Email</span>
          </label>

          <div>
            <select class="col-md-2 form-control device-list new-device"
                    [disabled]="formState.isSubmitted || !emailDevice.value.isChecked"
                    [ngrxFormControlState]="emailDevice.controls.deviceId">
              <option *ngFor="let device of devicesEmail$ | async"
                      [value]="device.deviceId">{{ device.deviceId }}</option>
            </select>
          </div>

        </div>
      </div>


      <div *ngIf="formState.controls.voiceDevice as voiceDevice">
        <div class="device-item">
          <label class="col-md-2">
            <input type="checkbox" [ngrxFormControlState]="voiceDevice.controls.isChecked"
                   [disabled]="formState.isSubmitted"/>
            <span style="margin-left:10px;text-transform: capitalize; ">Voice</span>
          </label>

          <div>
            <select class="col-md-2 form-control device-list new-device"
                    [disabled]="formState.isSubmitted || !voiceDevice.value.isChecked"
                    [ngrxFormControlState]="voiceDevice.controls.deviceId">
              <option *ngFor="let device of devicesVoice$ | async"
                      [value]="device.deviceId">{{ device.deviceId }}</option>
            </select>
          </div>

        </div>
      </div>

      <!-- We could traverse over an array like this but keeping the state structure simple helps us debugging

        <div *ngFor="let deviceControls of formState.controls.devices.controls">
          <div class="device-item">
            <label class="col-md-2">
              <input type="checkbox" [ngrxFormControlState]="deviceControls.controls.isChecked"/>
              <span style="margin-left:10px;text-transform: capitalize; ">{{deviceControls.controls.type}}</span>
            </label>
          </div>
        </div>

      -->

    </div>

    <div>
      <!-- formState.value.smsDevice.isSharedNumber={{formState.value.smsDevice.isSharedNumber}}<br/>
      {{formState.value.smsDevice | json }} -->
      <h3><span class="glyphicon glyphicon-warning-sign" style="color: red">&nbsp;Warning</span></h3>
      <ul style="padding-left: 25px; padding-top: 5px;">
        <li><span>Templates can override these by having their own devices defined, however we should avoid this.</span>
          <span *ngIf="formState.value.voiceDevice.isChecked
            || formState.value.smsDevice.isChecked
            || formState.value.emailDevice.isChecked"> If no device is selected here then the system defaults will be used.</span>

          <span *ngIf="!(formState.value.voiceDevice.isChecked
            || formState.value.smsDevice.isChecked
            || formState.value.emailDevice.isChecked)"
            style="color: red"> No user specific device selected - using system defaults</span>

        </li>
        <li *ngIf="(hasTwoWayPermission$ | async)
          && (isTwoWayAbleDevice(formState.value.smsDevice.deviceId) && formState.value.smsDevice.userSenderAddress === '')">
          <span style="color: red">Two-Way Texting requires selecting an SMS device with a phone number assigned to the
            user and only this one user.</span>
        </li>
        <li *ngIf="hasTwoWayPermission && !isTwoWayAbleDevice(formState.value.smsDevice.deviceId)">
          <span style="color: red">Two-Way Texting requires selecting an SMS device which can be used for Two-Way Texting</span>
        </li>
        <li *ngIf="hasTwoWayPermission && formState.value.smsDevice.isSharedNumber">
          <span style="color: red">A Shared number can not be used for Two-Way Texting. </span></li>
        <li *ngIf="hasTwoWayPermission
          && isTwoWayAbleDevice(formState.value.smsDevice.deviceId)
          && formState.value.smsDevice.userSenderAddress !== ''
          && !formState.value.smsDevice.isSharedNumber
          && !formState.value.smsDevice.hasAutoResponse">
          <!-- TODO: Get default auto response message from default device list and/or show which shared number -->
          <span style="color: red">The user did not yet setup auto response for selected Two Way SMS device - when saving the default from the shared number will be used
            <!-- '{{ formState.controls.smsDevice.controls.autoResponseMessage.value }}'-->.</span>
        </li>
      </ul>
    </div>

  </form>

</div>